import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

/**
 * Handles the redirect from Facebook OAuth.
 * URL format: /auth/callback/facebook?code=<CODE>&state=<STATE>
 * We parse the query string, POST it to /api/auth/facebook/exchange, then
 * redirect to /dashboard (or `state.from` if coming from a protected route).
 */
export default function FacebookAuthCallback() {
  const { refresh } = useAuth();
  const nav = useNavigate();
  const [status, setStatus] = useState("loading"); // loading | error
  const [error, setError] = useState("");

  useEffect(() => {
    const search = new URLSearchParams(window.location.search);
    const code = search.get("code") || "";
    const state = search.get("state") || "";
    const fbError = search.get("error_description") || search.get("error_message") || search.get("error");

    if (fbError) {
      setStatus("error");
      setError(fbError);
      return;
    }
    if (!code) {
      setStatus("error");
      setError("No se recibió el código de autorización de Facebook.");
      return;
    }

    const redirect_uri = `${window.location.origin}/auth/callback/facebook`;

    (async () => {
      try {
        await api.post("/auth/facebook/exchange", { code, redirect_uri, state });
        await refresh();
        window.history.replaceState({}, "", "/auth/callback/facebook");
        nav("/dashboard", { replace: true });
      } catch (e) {
        setStatus("error");
        setError(e.response?.data?.detail || e.message || "Error de sesión");
      }
    })();
    // eslint-disable-next-line
  }, []);

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center p-8" data-testid="auth-callback-facebook">
      {status === "loading" ? (
        <>
          <Loader2 size={24} className="animate-spin mb-4" style={{ color: "var(--brand-primary)" }} />
          <p className="text-sm" style={{ color: "var(--text-secondary)" }}>
            Validando tu cuenta de Facebook…
          </p>
        </>
      ) : (
        <>
          <p className="font-serif text-2xl mb-2" style={{ color: "#ef6d6d" }}>No pudimos iniciar sesión</p>
          <p className="text-sm mb-6" style={{ color: "var(--text-secondary)" }}>{error}</p>
          <a href="/login" className="btn-primary text-xs">Volver a intentar</a>
        </>
      )}
    </div>
  );
}
